// Lightweight logger that only emits in development builds.
// In production (NODE_ENV === "production") these are no-ops, so internal
// details and errors are not written to the browser console.
const isDev = process.env.NODE_ENV === "development";

export const logError = (...args) => {
  if (isDev) {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
};

export const logDebug = (...args) => {
  if (isDev) {
    // eslint-disable-next-line no-console
    console.debug(...args);
  }
};
